import styles from '../../../../styles'
import { WHITE } from '../../../../theme'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => (
		{
			...styles(theme),
			linkStyle: {
				display: 'contents'
			},
			titleStyle: {
				...styles(theme).title6,
				fontSize: 28,
				margin: '5px 0 15px 0'
			},
			dateText: {
				fontSize: 15,
				fontWeight: 500,
				color: theme.palette.blue.main,
				lineHeight: 1.33
			},
			inputTextColor: {
				...styles(theme).text1,
				color: theme.palette.blue['50']
			},
			languageItem: {
				textTransform: 'uppercase'
			},
			selectStyle: {
				...styles(theme).text1,
				fontSize: 15,
				fontWeight: 500,
				color: theme.palette.blue.main,
				lineHeight: 1.33,

				'& .MuiSelect-icon': {
					color: theme.palette.blue.main
				}
			},
			selectPlaceholderStyle: {
				...styles(theme).text1,
				fontSize: 15,
				fontWeight: 500,
				color: theme.palette.blue.main,
				lineHeight: 1.33,

				'& .MuiSelect-icon': {
					color: theme.palette.blue.main
				}
			},
			itemStyle: {
				opacity: 1
			},
			fabContainer: {
				'& button': {
					boxShadow: 'none',
					width: '100%',
					minHeight: 51,
					...styles(theme).text4,
					fontSize: 12,
					textTransform: 'initial'
				}
			},
			labelStyle: {
				marginBottom: 8
			},
			requiredField: {
				marginTop: 10
			},
			marginTop: {
				marginTop: 30,
				fontSize: 12.8
			},
			dateContainer: {
				'& > div': {
					padding: '12px 8px 10px 20px',
					boxSizing: 'border-box',
					backgroundColor: WHITE
				}
			},
			marginInputTop: {
				marginTop: 10
			},
			marginBackInputTop: {
				marginTop: 15
			},
			infoContainer: {
				marginTop: 10
			},
			studentProfileItem: {
				...styles(theme).text1,
				wordBreak: 'break-all',
				margin: 0,
				opacity: 0.7
			},
			btnContinue: {
				textAlign: 'right',
				paddingRight: 8
			},
			buttonLongText: {
				width: '100%',
				padding: '15px 6px',

				'& > span:first-child': {
					marginLeft: isLargeScreen ? 25 : 0
				}
			},
			requiredMarginTop: {
				marginTop: 30
			},
			bottomButtons: {
				marginTop: 10
			},
			textFieldContainer: {
				marginTop: 0
			},
			fieldArrayStyle: {
				paddingBottom: 40
			},
			loaderMargin: {
				marginTop: 20
			},
			formContainer: {
				width: '100%'
			},
			formContainerStep3: {
				marginTop: 30
			},
			textFontSize: {
				fontSize: 16
			},
			requiredFieldsClass: {
				marginTop: 30
			},
			marginBottom: {
				marginBottom: -12
			},
			marginTitleBottom: {
				marginBottom: 10
			},
			incomeStyle: {
				paddingTop: 10,
				margin: '0 10px 0 10px',
				paddingBottom: 16,

				'& input': {
					textAlign: 'center'
				},
				'& div:first-child': {
					padding: 5
				}
			},
			secondIncomeStyle: {
				paddingTop: 10,
				margin: '0 10px 0 0',
				paddingBottom: 16,
				'& input': {
					textAlign: 'center'
				},
				'& div:first-child': {
					padding: '4px 20px 4px 20px'
				}
			},
			alignEnd: {
				alignSelf: 'self-end'
			},
			widthInherit: {
				position: 'relative',
				width: 'inherit'
			},
			errorStyle: {
				color: '#B92D00',
				fontSize: 10,
				paddingLeft: 15,
				paddingBottom: '5px'
			},
			fabHover: {
				'&:hover': {
					backgroundColor: `${WHITE} !important`
				}
			},
			noLeftMargin: {
				marginLeft: 0,

				'& div': {
					paddingTop: '0 !important'
				},
				'& div:first-child': {
					paddingLeft: 0
				},
				'& div:last-child': {
					paddingRight: 0
				}
			},
			chevronLeftIcon: {
				position: isLargeScreen ? 'absolute' : 'inherit',
				left: 15
			},
			overflowHidden: {
				overflow: 'hidden'
			},
			noTopMargin: {
				marginTop: 0
			},
			submitErrorContainer: {
				marginTop: 10,
				marginBottom: 10,

				'& > div': {
					padding: 0
				}
			}
		}
	)
)
